module.exports = __webpack_public_path__ + "media/images/prizes__prizeFg--8-7bc9e78de4a3ec8e860d5120aec23356.png";